import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import queryString from 'query-string'
import moment from 'moment'

import ManagerOrders from './../../../../../../../../js/classes/ManagerOrders.js'
import CurrencyClass from './../../../../../../../../js/classes/Currency.js'

import Loading from './../Loading.jsx'

import './../css/order.scss'

const Order = ({  }) => {
    const params = queryString.parse(location.search),
    ORDER_ID = parseInt(params.ORDER_ID),
    [data, setData] = useState(null),
    [isLoading, setLoading] = useState(false)

    const refetch = (cb, orderID) => {
        setLoading(true)

        ManagerOrders.getOrder((err, res) => {
            if (err) {
                console.log(err)
            } else {
                res.properties.forEach((propertyGroup) => {
                    if (propertyGroup.PROPERTIES && propertyGroup.PROPERTIES.length > 0) {
                        propertyGroup._PROPERTIES = propertyGroup.PROPERTIES.reduce((r, el) => {
                            r[el.CODE] = el

                            return r
                        }, {})
                    } else {
                        propertyGroup._PROPERTIES = []
                    }
                })
                
                console.log(res)

                setData(res.order ? res : null)
                setLoading(false)

                if (cb) cb()
            }
        }, orderID)
    }

    useEffect(() => {
        if (ORDER_ID > 0) {
            refetch(() => {

            }, ORDER_ID)
        }
    }, [])

    if (isLoading) {
        return <div className="manager manager_order">
            <div className="manager__inner">
                <Loading />
            </div>
        </div>
    } else if (data) {
        return <div className="manager manager_order">
            <div className="manager__inner">
                <div className="manager__header">
                    <a href="/manager/orders/" className="manager__button">Вернуться к заказам</a>
                </div>
        
                <div className="manager__header-title">
                    <h1 className="manager__h1">Заказ { data.order.ACCOUNT_NUMBER } [{ data.order.ID }]</h1>
                    <div className="manager__order-date">от { moment(data.order.DATE_INSERT.ISO).format('DD.MM.YYYY HH:mm:ss') }</div>
                </div>

                <div className="manager__actions">
                    <div className="manager__status">
                        <div className="manager__custom-select">
                            <select defaultValue={ data.order.STATUS_ID }>
                                { data.statuses.map((status) => {
                                    return <option
                                        key={ `order-statuses-${ status.ID }` }
                                        value={ status.STATUS_ID }
                                    >
                                        { status.NAME }
                                    </option>
                                }) }
                            </select>
                        </div>

                        <div className="manager__status-actions">
                            <button className="manager__button">Сменить статус</button>
                            <button className="manager__button manager__button-warning">Отменить</button>
                        </div>
                    </div>

                    <div className="manager__1c">
                        <button className="manager__button">Перенести заказ в 1С</button>
                    </div>
                </div>

                <div className="manager__summary">
                    <div className="manager__block">
                        <div className="manager__node">
                            <div className="manager__field-inline">
                                <strong>Сумма заказа (с доставкой):</strong> { CurrencyClass.format(data.order.PRICE) }
                            </div>

                            <div className="manager__field-inline">
                                <strong>Сумма товаров:</strong> { CurrencyClass.format(data.order.CART.summary) } { data.order.CART.discount_summary > 0 ? <strike>({ data.order.CART.discount_summary_format })</strike> : null }
                            </div>
                        </div>

                        <div className="manager__node">
                            <div className="manager__field-inline">
                                <strong>Способ оплаты:</strong> «{ data.order.PAYMENT.NAME }» <span className="manager__field-edit">[изменить]</span>
                            </div>

                            <div className="manager__field-inline">
                                <strong>Сумма к оплате:</strong> { CurrencyClass.format(data.order.PRICE - data.order.SUM_PAID) } { (data.order.PAYED == 'Y') ? <span className="manager__field-payed">Оплачено</span> : <span className="manager__field-payed manager__field-payed_n">Не оплачено</span> } <span className="manager__field-edit">[изменить]</span>
                            </div>

                            <div className="manager__field-inline">
                                <strong>Оплачено:</strong> { CurrencyClass.format(data.order.SUM_PAID) }
                            </div>
                        </div>

                        <div className="manager__node">
                            { data.order.CANCELED && data.order.REASON_CANCELED ? <div className="manager__cancel-reason">
                                <div className="manager__field">
                                    <div className="manager__field-key">
                                        Причина отмены заказа: 
                                    </div>
                                    <div className="manager__field-inlvalueine">
                                        { data.order.REASON_CANCELED }
                                    </div>
                                </div>
                            </div> : null }
                        </div>
                    </div>
                </div>
                
                <div className="manager__summary">
                    <div className="manager__block">
                        <div className="manager__node">
                            <div className="manager__title">
                                «{ data.order.PERSON ? data.order.PERSON.NAME : 'Тип плательщика не найден' }»
                            </div>

                            { data.properties.map((propertyGroup) => {
                                if ((propertyGroup.ID == 1 || propertyGroup.ID == 3) && propertyGroup.PERSON_TYPE_ID == data.order.PERSON_TYPE_ID) {
                                    return <div key={ `order-property-group-person-${ propertyGroup.ID }` } className="manager__property-group">
                                        <div className="manager__title manager__title_big">
                                            { propertyGroup.NAME }
                                        </div>

                                        { data.order.PROPERTIES.map((property) => {
                                            if (propertyGroup._PROPERTIES[property.CODE]) {
                                                return <div key={ `order-${ data.order.ID }-${ propertyGroup.ID }-properties-${ property.ID }` } className="manager__field">
                                                    <div className="manager__field-key">
                                                        { property.NAME }:
                                                    </div>
                                                    <div className="manager__field-value" title={ property.VALUE }>
                                                        { property.VALUE ? property.VALUE :'- Не указано -' }
                                                    </div>
                                                </div>
                                            }
                                            
                                            return null
                                        }) }
                                    </div>
                                }

                                return null
                            }) }
                        </div>

                        <div className="manager__node">
                            <div className="manager__title manager__title_big">
                                Доставка
                            </div>

                            <div className="manager__field">
                                <div className="manager__field-key">
                                    Способ доставки <span className="manager__field-edit">[изменить]</span>:
                                </div>
                                <div className="manager__field-value" title="{{ data.ORDER.DELIVERY.NAME }}">
                                    «{ data.order.DELIVERY.NAME }»
                                </div>
                            </div>

                            <div className="manager__field-inline">
                                <strong>Стоимость доставки:</strong> { CurrencyClass.format(data.order.PRICE_DELIVERY) }
                            </div>

                            { data.order.TRACKING_NUMBER ? <div className="manager__field">
                                <div className="manager__field-key">
                                    Трекномер: 
                                </div>
                                <div className="manager__field-value" title={ data.order.TRACKING_NUMBER }>
                                    { data.order.TRACKING_NUMBER }
                                </div>
                            </div> : null }

                            { data.order.STORE ? <div className="manager__store">
                                <div className="manager__store-label">
                                    Пункт выдачи: 
                                </div>
                                <div>
                                    <div className="manager__store-title">
                                        { data.order.STORE.TITLE }
                                    </div>
                                    <div className="manager__store-value">
                                        { data.order.STORE.ADDRESS }
                                    </div>
                                </div>
                            </div> : null }
                        </div>

                        <div className="manager__node">
                            { data.properties.map((propertyGroup) => {
                                if ((propertyGroup.ID == 2 || propertyGroup.ID == 4) && propertyGroup.PERSON_TYPE_ID == data.order.PERSON_TYPE_ID) {
                                    return <div key={ `order-property-group-person-${ propertyGroup.ID }` } className="manager__property-group">
                                        <div className="manager__title manager__title_big">
                                            { propertyGroup.NAME }
                                        </div>

                                        { data.order.PROPERTIES.map((property) => {
                                            if (propertyGroup._PROPERTIES[property.CODE]) {
                                                return <div key={ `order-${ data.order.ID }-${ propertyGroup.ID }-properties-${ property.ID }` } className="manager__field">
                                                    <div className="manager__field-key">
                                                        { property.NAME }:
                                                    </div>
                                                    <div className="manager__field-value" title={ property.VALUE }>
                                                        { property.VALUE ? property.VALUE :'- Не указано -' }
                                                    </div>
                                                </div>
                                            }
                                            
                                            return null
                                        }) }
                                    </div>
                                }

                                return null
                            }) }
                        </div>
                    </div>
                </div>

                {/*<div className="manager__products">
                    <div className="manager__products-header">

                    </div>

                    <div className="manager__products-list">
                        <div className="manager__table">
                            <div className="manager__table-header">
                                <div className="manager__table-tr">
                                    <div className="manager__table-th">
                                        Фото
                                    </div>
                                    <div className="manager__table-th manager__table-th_name">
                                        Наименование
                                    </div>
                                    <div className="manager__table-th">
                                        Кол-во
                                    </div>
                                    <div className="manager__table-th">
                                        Остаток
                                    </div>
                                    <div className="manager__table-th">
                                        Цена
                                    </div>
                                    <div className="manager__table-th">
                                        Сумма
                                    </div>
                                    <div className="manager__table-th">
                                        —
                                    </div>
                                </div>
                            </div>
                            <div className="manager__table-body">
                                {% for PRODUCT in data.ORDER.BASKET.ITEMS %}
                                    <div className="manager__table-tr">
                                        <div className="manager__table-td">
                                            <a href="{{ PRODUCT.DETAIL_PAGE_URL }}" className="manager__products-image-link" target="_blank" style="background-image:url('{{ PRODUCT.PREVIEW_PICTURE|resizeImage(220, 220, 100, false) }}');"></a>
                                        </div>
                                        <div className="manager__table-td manager__table-td_name">
                                            <a href="{{ PRODUCT.DETAIL_PAGE_URL }}" className="manager__products-link" target="_blank">
                                                {{ PRODUCT.NAME }}
                                            </a>
                                        </div>
                                        <div className="manager__table-td">
                                            <span className="manager__no-wrap manager__table-product-edit manager__table-product-amount">{{ PRODUCT.QUANTITY }} шт.</span>
                                        </div>
                                        <div className="manager__table-td">
                                            <span className="manager__no-wrap">{{ PRODUCT.AMOUNT|default('0') }} шт.</span>
                                        </div>
                                        <div className="manager__table-td">
                                            <span className="manager__no-wrap manager__table-product-edit manager__table-product-price">{{ PRODUCT.PRICE|currencyFormat(data.ORDER.CURRENCY) }}</span>

                                            {% if PRODUCT.BASE_PRICE > PRODUCT.PRICE %}
                                                <br /><strike className="manager__no-wrap">{{ PRODUCT.BASE_PRICE|currencyFormat(data.ORDER.CURRENCY) }}</strike>
                                            {% endif %}
                                        </div>
                                        <div className="manager__table-td">
                                            <span className="manager__no-wrap">{{ PRODUCT.SUMMARY|currencyFormat(data.ORDER.CURRENCY) }}</span>

                                            {% if PRODUCT.BASE_PRICE > PRODUCT.PRICE %}
                                                <br /><strike className="manager__no-wrap">{{ (PRODUCT.BASE_PRICE * PRODUCT.QUANTITY)|currencyFormat(data.ORDER.CURRENCY) }}</strike>
                                            {% endif %}
                                        </div>
                                        <div className="manager__table-td">
                                            <button className="manager__table-td-remove" title="Удалить товар из заказа"></button>
                                        </div>
                                    </div>
                                {% endfor %}
                            </div>
                        </div>
                    </div>

                    <div className="manager__products-footer">
                        <div className="manager__products-promo">

                        </div>

                        <button className="manager__button">Добавить товар к заказу</button>
                    </div>
                </div>*/}
            </div>
        </div>
    } else {
        return <div className="manager manager_order">
            <div className="manager__inner">
                <div className="manager__header">
                    <a href="/manager/orders/" className="manager__button">Вернуться к заказам</a>
                </div>

                <div className="manager__header-title">
                    <h1 className="manager__h1">Заказ { ORDER_ID } не найден</h1>
                </div>
            </div>
        </div>
    }
}

export default Order